import { Injectable } from '@angular/core';
import { FogDashboardService } from '../fog-dashboard.service';
import * as L from 'leaflet'
import { AgricultureMapConstants, LAYER_TYPES } from 'src/app/main/constants/dims-map-constants';
import { isNullOrUndefined } from 'util';
import { ADMIN_LOCATION_HIE, ALERT_COLOR_MAPPING, FOG_LAYER_LIST, FOG_LEGEND_LIST, FOGALERT_API_MAPPING, FOGALERT_VIEWTYPE, FogMapConstants, FORMAT_VS_SOURCEMAPPING, SECTOR_ICON_CLASS } from './fog-map-constants';
import { isEmptyObject } from 'jquery';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { MapConstants } from 'src/app/utils/map.constant';
import { HttpClient } from '@angular/common/http';
import { UtilsService } from 'src/app/utils/utils.service';
import * as R from 'leaflet-responsive-popup'
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class FogMapService {

  concentricCircleLayer = new L.LayerGroup();
  disasterData: any = []
  fogData: any;
  selectedSource: any
  stateBoundary: any;
  heatMapLayerList: any = [];
  isDistrictChecked: boolean = false;
  isAviationChecked: boolean = false;
  isRailwayChecked: boolean = false;
  isHighwayChecked: boolean = false;
  fogInfoCountData: any;
  gisMapComp: any;
  activeGroup: any;
  fogAlertLayersList = ['Airport', 'Railway', 'Highway']
  aviationFogData: any = {}
  railwayFogData: any = {}
  highwayFogData: any = {}
  alertDataMap: any = {
    Railway: 'railwayFogData',
    Highway: 'highwayFogData',
    Airport: 'aviationFogData'
  }
  cTypeMapping: any = {
    Railway: 'RAILWAY_LINE',
    Highway: 'HIGHWAY_LINE',
    Airport: 'AVIATION'
  }
  propertiesMapping: any = {
    Railway: 'dist',
    Highway: 'NH_NAME',
    Airport: 'airport_na'
  }
  toggleSectorLayerMap: any = {
    Airport: 'isAviationChecked',
    Railway: 'isRailwayChecked',
    Highway: 'isHighwayChecked'
  }
  infoboxComp: any
  private cancelSectorWiseAPICall$ = new Subject<void>();
  selectedFogView: any;
  selectedFormat: any;
  subscriptions: any = []
  selectedLocType: any = null;
  constructor(private fogSrv: FogDashboardService, private http: HttpClient, private utils: UtilsService) { }


  async getSrcWiseLayers(gisMapComp: any) {
    this.gisMapComp = gisMapComp
    gisMapComp.legendList = {};
    gisMapComp.labelStrings = []
    gisMapComp.showThrobber = true;
    gisMapComp.map.closePopup()
    // gisMapComp.toggleButtons.overlaylayerControl = false;    
    let queryParams: any = gisMapComp['params'];
    gisMapComp.otherOptions.showNgxPlaybar = queryParams.fogView == 'forecast' && queryParams.format == 'HOURLY' ? true : false
    gisMapComp.selectedSource = queryParams['source']
    gisMapComp.getAndSetBaseLayers(2) // for dark background
    if (!isNullOrUndefined(queryParams) && Object.keys(queryParams).length > 0) {
      let layerList:any = {}
      let layerName: any;
      let hie = ADMIN_LOCATION_HIE
      layerName = gisMapComp.gisUtils.titleCase(hie[hie.indexOf(queryParams.locType) + 1])
      layerList[layerName + ' Boundary'] = FOG_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][layerName + ' Boundary']
      if (layerName != 'State') {
        layerList[layerName + ' Boundary Labels'] = FOG_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][layerName + ' Boundary Labels']
      }
      if (queryParams.locType != 'COUNTRY') {
        layerList[gisMapComp.gisUtils.titleCase(queryParams.locType)] = FOG_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][gisMapComp.gisUtils.titleCase(queryParams.locType) + ' Boundaries'];
        this.addSrcWiseGeoJSONLayers(gisMapComp, layerList, queryParams)
        /*Adding mask layer */
        layerList = gisMapComp.gisdataService.addMaskLayer(layerList, queryParams, gisMapComp.params.component)
      } else {
        layerList['India Boundary'] = FOG_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['India Boundary']
      }

      this.addSrcWiseVectorLayers(layerList, gisMapComp, queryParams)
      this.addSrcWiseWMSLayers(layerList, gisMapComp, queryParams);
      if (this.selectedSource != queryParams.source || this.selectedFogView != queryParams.fogView || this.selectedFormat != queryParams.format) {
        this.selectedSource = queryParams.source
        this.selectedFogView = queryParams.fogView
        this.selectedFormat = queryParams.format
        this.removeHeatMapLayers(gisMapComp)
        this.resetVariables()
        this.setToggleVariables('')
      }
      if (this.heatMapLayerList.length > 0) {
        this.addHeatMapLayers(gisMapComp, this.heatMapLayerList)
        gisMapComp.showThrobber = false
      } else {
        this.addHeatMapsForFog(gisMapComp, queryParams)
      }
      this.utils.fogDistrictLayerToggle.subscribe(data => {
        if (!isNullOrUndefined(data)) {
          this.isDistrictChecked = data
          if (data) {
            layerList['District Boundary'] = FOG_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA]['District Boundary']
            this.addSrcWiseVectorLayers(layerList, gisMapComp, queryParams)
            // gisMapComp.otherOptions.showFogLegend = true
          } else if (!data && queryParams.locType != 'STATE') {
            this.removeToggledLayer(gisMapComp, 'District')
          }
          this.setToggleVariables('')
        }
      })
      if (queryParams.fogView == 'observed') {
        this.setToggleVariables('')
      }
      gisMapComp.otherOptions.onLocationClick = queryParams.locType == 'DISTRICT' ? false : true;
    }
  }

  async handleSectorWiseLayers(gisMapComp:any, queryParams:any, layerName:any, layerChecked:any , forceReload:boolean=false) {
    // console.log("handleSectorWiseLayers", layerName, layerChecked);
    let sectorLayerList:any = {}
    for (let index in this.fogAlertLayersList) {
      let sectorName = this.fogAlertLayersList[index]
      let sectorLayer = sectorName + ' Boundary'
      if (layerName == sectorLayer && layerChecked) {
        this.setToggleVariables(sectorName, layerChecked)
        this.setInfoboxView(sectorLayer)
        let response = await this.getSectorFogAlertData(gisMapComp, sectorName)
        sectorLayerList[layerName] = FOG_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][layerName]
        if (sectorName == 'Airport') {
          this.addSrcWiseGeoJSONLayers(gisMapComp, sectorLayerList,queryParams)
        } else {
          this.addSrcWiseVectorLayersForFogAlert(sectorLayerList, gisMapComp, queryParams, response)
        }
        // gisMapComp.otherOptions.onLocationClick = false
      } else if (layerName == sectorLayer && !layerChecked) {
        this.removeToggledLayer(gisMapComp, sectorName)
        this.setToggleVariables(sectorName, layerChecked)
        this[this.alertDataMap[sectorName]] = {}  
        this.selectedLocType = null  
      } else {
        this.removeToggledLayer(gisMapComp, sectorName)
        if (sectorName === 'Airport') {
            this.selectedLocType = null  
        }
      }
      gisMapComp.otherOptions.showFogLegend = layerChecked
      gisMapComp.otherOptions.onLocationClick = !layerChecked
    }
  }

  setToggleVariables(sectorName:any, layerChecked?:any) {
    Object.keys(this.toggleSectorLayerMap).forEach(key => {
      if (key == sectorName && layerChecked) {
        this[this.toggleSectorLayerMap[key]] = true
      } else {
        this[this.toggleSectorLayerMap[key]] = false
      }
    })
  }

  setInfoboxView(layerName:any) {
    Object.keys(this.toggleSectorLayerMap).forEach(key => {
      if (this[this.toggleSectorLayerMap[key]]) {
        this.setFogAlertViewInInfobox(true, layerName)
      }
    })
  }

  setFogAlertViewInInfobox(setView:any, type:any) {
    let infoObj: any = {}
    if (setView) {
      infoObj = {
        view: FOGALERT_VIEWTYPE[type],
        showAlert: false
      }
    }
    this.utils.setViewForFogAlert.next(infoObj)
  }

  resetVariables() {
    this.heatMapLayerList = []
    this.aviationFogData = {}
    this.railwayFogData = {}
    this.highwayFogData = {}
  }

  removeToggledLayer(gisMapComp:any, layerName:any) {
    for (let key in gisMapComp.layers.overlaylayers) {
      if (gisMapComp.layers.overlaylayers[key] && key == layerName + ' Boundary' && gisMapComp.map.hasLayer(gisMapComp.layers.overlaylayers[key])) {
        gisMapComp.map.removeLayer(gisMapComp.layers.overlaylayers[key])
      }
    }
  }

  addSrcWiseGeoJSONLayers(gisMapComp: any, layerList: any, queryParams?: any) {
    // if (this.selectedLocType == queryParams.locType) return;
    this.selectedLocType = queryParams.locType;
    let geoJsonLayersBasedOnView = gisMapComp.gisdataService.getApplicationBasedLayer(layerList, LAYER_TYPES.GEOJSON_LAYER);
    geoJsonLayersBasedOnView = this.formatLayersData(gisMapComp, geoJsonLayersBasedOnView);
    // Reset the map component's locType guard before each call so that switching
    // between states (same locType, different pUUID) always re-renders the GeoJSON.
    gisMapComp.selectedLocType = null;
    gisMapComp.addSrcWiseGEOJSONLayers(geoJsonLayersBasedOnView, queryParams);
  }

  async addHeatMapsForFog(gisMapComp:any, queryParams:any) {
    this.heatMapLayerList = await this.createAllHeatMapLayers(queryParams)
    this.addHeatMapLayers(gisMapComp, this.heatMapLayerList)
  }

  async createAllHeatMapLayers(queryParams:any) {
    // let nowcastHeatMapsData:any = await this.getNowcastHeatMapData()
    // let forecastheatMapsData:any = await this.getForecastHeatMapData(queryParams)
    let heatMapsData = queryParams.fogView == 'observed' ? await this.getNowcastHeatMapData() : await this.getForecastHeatMapData(queryParams)
    let type = queryParams.fogView == 'observed' ? 'Observed' : 'Forecast'
    // let data = await Promise.all([nowcastHeatMapsData, forecastheatMapsData]).then((payloads) => {
    let data = await Promise.all([heatMapsData]).then((payloads:any) => {
      const urls: any = [];
      let blockIndex: any = 0
      for (let i = 0; i < 1; i++) {
        if (!isNullOrUndefined(payloads[i]) && !isEmptyObject(payloads[i])) {
          let timeKeysList: any = Object.keys(payloads[i]);
          timeKeysList.sort()
          timeKeysList = queryParams.fogView == 'observed' ? timeKeysList : this.fogSrv.filterTodayTimestamps(timeKeysList)
          for (let j = 0; j < timeKeysList.length; j++) {
            let imageURL = payloads[i][timeKeysList[j]]['heatMapImage']
            if (imageURL.split(',')[1] != 'null') {
              const layerObj = { ...FogMapConstants["HeatMapOptions"] };
              layerObj['animationType'] = 'Time';
              layerObj['time'] = '24';
              // layerObj['clip'] = true;
              layerObj['view'] = 'Admin';
              // layerObj['serviceType'] = 'HeatMap';
              if (i == 0 && blockIndex == 0) {
                layerObj['setDefault'] = 'true';
              } else {
                layerObj['setDefault'] = 'false';
              }
              layerObj['opacity'] = 0.6
              layerObj['groupName'] = timeKeysList[j].toString();
              layerObj['timeLineName'] = {};
              // if (i == 0) { // last 3 days observed RF data
              layerObj['timeLineName']['toolTip'] = this.fogSrv.convertTimestampToFullBlockValue(timeKeysList[j]);
              layerObj['timeLineName']['label'] = this.fogSrv.convertTimestampToDateBlockValue(timeKeysList[j], queryParams, type)
              layerObj['url'] = payloads[i][timeKeysList[j]]['heatMapImage']
              layerObj['imageBounds'] = this.fogSrv.getImageBounds(this.fogSrv.getHeatMapImageBounds(payloads[i][timeKeysList[j]]['heatMapImageBound']));
              // layerObj['imageBounds'] = this.fogSrv.getImageBounds(this.fogSrv.getHeatMapImageBounds({
              //   "southWest": {
              //     "latitude": 6.33,
              //     "longitude": 67.57
              //   },
              //   "northEast": {
              //     "latitude": 35.40,
              //     "longitude": 97.23
              //   }
              // }));
              layerObj['timeLinePos'] = blockIndex;
              layerObj['leftSideName'] = layerObj['timeLineName']['toolTip']
              layerObj['type2'] = type
              layerObj['name'] = 'Rainfall Heatmap'
              urls.push(layerObj);
              blockIndex++;
              // }
            }
          }
        }

      }
      return urls
    })
    return data
  }

  getForecastHeatMapData(queryParams:any) {
    return new Promise((resolve, reject) => {
      let src = FORMAT_VS_SOURCEMAPPING[queryParams.format][queryParams.source]
      this.fogSrv.getHeapMapsForFogForecast(src).subscribe(response => {
        resolve(response);
      }, err => {
        resolve({})
      })
    })
  }

  getNowcastHeatMapData() {
    return new Promise((resolve, reject) => {
      this.fogSrv.getHeapMapsForFogNowcast().subscribe(response => {
        resolve(response);
      }, err => {
        resolve({})
      })
    })
  }

  async addHeatMapLayers(gisMapComp:any, layerList:any) {
    let labels = []
    this.removeHeatMapLayers(gisMapComp)
    for (let key in layerList) {
      let layer = layerList[key]
      let layerObj: any = await this.createHeatMapLayer(layer, gisMapComp)
      gisMapComp.layers.heatmaplayers[key] = layerObj
      gisMapComp.activeLayers[key] = layerObj;
      if (!isNullOrUndefined(layerObj['layer'])) {
        labels[layer['timeLinePos']] = {
          groupName: layer['groupName'],
          label: layer['timeLineName'],
          fullLabel: layer['leftSideName'],
          type: layer['type2']
        }
        if (layerObj['setDefault'] == 'true') {
          gisMapComp['map'].addLayer(layerObj['layer'])
          gisMapComp.activeGroup = layer['groupName']
          this.activeGroup = layer['groupName']
          this.updateFogHeaderCount(gisMapComp)
        }
      }
    }

    gisMapComp.labelStrings = labels
    if (gisMapComp.labelStrings.length > 0) {
      gisMapComp.initialCounter = parseInt(gisMapComp.labelStrings[0]['groupName'], 10);
    }
    gisMapComp.showThrobber = false
  }

  removeHeatMapLayers(gisMapComp:any) {
    for (const key in gisMapComp.layers.heatmaplayers) {
      if (gisMapComp.map.hasLayer(gisMapComp.layers.heatmaplayers[key]['layer'])) {
        gisMapComp.map.removeLayer(gisMapComp.layers.heatmaplayers[key]['layer'])
      }
      delete gisMapComp.layers.heatmaplayers[key];
    }
  }

  createHeatMapLayer(layer:any, gis:any) {
    const layerPromise = new Promise((resolve, reject) => {
      const options = {
        opacity: 0.8,
        pane: 'heatMap',
        minZoom: 6,
        maxZoom: 15
      };

      // this.getShapeBoundaryLayers(layer.view, layer.clip).then(
      //   data => {
      // if (data != null) {
      // options['clip'] = data;
      // }
      if (layer.url != null && layer.url != undefined) {
        const anchors = layer['imageBounds'];
        layer['layer'] = L.imageTransform(layer['url'], anchors, options);
        layer['layer'].addTo(gis.map);
        gis.map.removeLayer(layer['layer']);
        resolve(layer);
      }
      // });
    });
    return layerPromise;
  }

  getShapeBoundaryLayers(view:any, clip?:any) {
    const shapeBoundary = new Promise((resolve, reject) => {
      if (clip == false) {
        resolve(null);
      }
      if (view == 'Admin') {
        if (this.stateBoundary == null || this.stateBoundary == undefined) {
          const layerName = 'odisha' + ':' + ProjConstants.STATE_TO_LAYERTYPE_NAME['INDIA_BOUNDARY'];
          const boundaryURL = MapConstants.GEOJSON_BOUNDARY_LAYER_URL + '&typeName=' + layerName
          this.http.get(boundaryURL).subscribe(
            (data:any) => {
              this.stateBoundary = data['features'][0]['geometry'];
              resolve(this.stateBoundary);
            });
        } else {
          resolve(this.stateBoundary);
        }
      }
    });
    return shapeBoundary;
  }

  async addSrcWiseVectorLayers(layerList: any, gisMapComp: any, queryParams: any) {
    // console.log(layerList, "vectorLayersBasedOnView");
    let vectorLayersBasedOnView = gisMapComp.gisdataService.getApplicationBasedLayer(layerList, LAYER_TYPES.VECTOR_LAYER);

    vectorLayersBasedOnView = this.addSourceWiseLayers(gisMapComp, vectorLayersBasedOnView, queryParams);
    for (let layer in layerList) {
      if (layerList[layer].applycql_filter) {
        vectorLayersBasedOnView = this.formatVectorLayersData(vectorLayersBasedOnView, queryParams, gisMapComp);
      }
    }
    this.setVectorLayerStyles(vectorLayersBasedOnView, gisMapComp, this.isDistrictChecked);
    gisMapComp.addSrcWiseVECTORLayers(vectorLayersBasedOnView);
    this.addLegend(gisMapComp)
  }

  async addSrcWiseVectorLayersForFogAlert(layerList: any, gisMapComp: any, queryParams: any, fogAlertData:any) {
    // console.log(layerList, "vectorLayersBasedOnView");
    let vectorLayersBasedOnView = gisMapComp.gisdataService.getApplicationBasedLayer(layerList, LAYER_TYPES.VECTOR_LAYER);

    vectorLayersBasedOnView = this.addSourceWiseLayers(gisMapComp, vectorLayersBasedOnView, queryParams);
    for (let layer in layerList) {
      if (layerList[layer].applycql_filter) {
        vectorLayersBasedOnView = this.formatVectorLayersData(vectorLayersBasedOnView, queryParams, gisMapComp);
      }
    }
    let groupName = queryParams['fogView'] == 'forecast' && queryParams['format'] == 'DAILY' ? this.fogSrv.convertMillisToYYYYMMDD(gisMapComp.activeGroup) : gisMapComp.activeGroup
    this.setVectorLayerStylesForFogAlert(vectorLayersBasedOnView, gisMapComp, fogAlertData, groupName);
    gisMapComp.addSrcWiseVECTORLayers(vectorLayersBasedOnView);
  }

  addSourceWiseLayers(gisMapComp: any, layerList?: any, params?: any, queryParams?: any) {
    let currTs: any = new Date().getTime();
    let layers: any = {};
    for (var i in layerList) {
      layers[i] = layerList[i];
      gisMapComp.activeLayers[i] = layerList[i].layerOptions.visible;
    }
    return layers;
  }

  formatVectorLayersData(layerList: any, queryParams?: any, gisMapComp?: any) {
    if (!isNullOrUndefined(queryParams)) {
      for (let layerName in layerList) {
        let uuid: any = queryParams['pUUID'];
        if (queryParams.locType == 'COUNTRY' && layerName == 'District Boundary') {
          layerList[layerName].layerOptions.cql_filter_value = null
          layerList[layerName].layerOptions.cql_filter = '1=1';
        }
        if (queryParams['locType'] == 'STATE' && layerName == 'District Boundary') {
          layerList[layerName].layerOptions.cql_filter_value = 'state_uuid'
          layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + uuid + "'";
        }
        if (queryParams['locType'] == 'DISTRICT' && layerName == 'Block Boundary') {
          layerList[layerName].layerOptions.cql_filter_value = 'dist_uuid'
          layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + uuid + "'";
        }
      }
      return layerList;
    }
  }

  async addSrcWiseWMSLayers(layerList: any, gisMapComp: any, queryParams: any) {
    let wmsLayersBasedOnView = gisMapComp.gisdataService.getApplicationBasedLayer(layerList, LAYER_TYPES.WMS_LAYER);
    wmsLayersBasedOnView = this.addSourceWiseLayers(gisMapComp, wmsLayersBasedOnView, queryParams);
    for (let layer in layerList) {
      if (layerList[layer].applycql_filter) {
        wmsLayersBasedOnView = this.formatWmsLayersData(wmsLayersBasedOnView, queryParams);
      }
    }
    gisMapComp.addSrcWiseWMSLayers(wmsLayersBasedOnView);
  }

  formatWmsLayersData(layerList: any, queryParams?: any) {
    if (!isNullOrUndefined(queryParams)) {
      for (let layerName in layerList) {
        if (queryParams.locType == 'DISTRICT') {
          let allLocations = queryParams.location.split('&')
          let districtUUID = allLocations[2].split('##')[1]
          if (layerList[layerName].layerOptions.cql_filter_value) {
            layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + districtUUID + "'";
          }
        }
        if (layerName.includes('world_view')) {
          let uuid: any = queryParams.pUUID;
          if (!isNullOrUndefined(queryParams.type)) {
            layerList[layerName].layerOptions.cql_filter = queryParams.locType == 'VILLAGE' ? '1=1;village_uuid' + "='" + uuid + "'" : '1=1;' + AgricultureMapConstants.LOCTYPE_CQLFILTERVALUE[queryParams.locType] + "='" + uuid + "'";
          } else {
            layerList[layerName].layerOptions.cql_filter = '1=1;' + AgricultureMapConstants.LOCTYPE_CQLFILTERVALUE[queryParams.locType] + "='" + uuid + "'";
          }
        }
      }
      return layerList;
    }
  }

  addLegend(gisMapComp:any) {
    for (const key in FOG_LEGEND_LIST[AgricultureMapConstants.LOCATIONS.INDIA]) {
      gisMapComp['legendList'][key] = FOG_LEGEND_LIST[AgricultureMapConstants.LOCATIONS.INDIA][key];
    }
    gisMapComp.manageLegend();
  }

  handleAdminPolygons(layer: any, mapObj: any, params: any, gisMapComp: any) {
    layer.setStyle({
      color: '#000000',
      fill: false,
      weight: 1.5,
    });
  }

  handleAirportPointLayer(feature: any, mapObj: any, params: any, gisMapComp: any) {
    // gisMapComp.showThrobber = true;
    let latLng: [number, number];
    latLng = [feature.geometry.coordinates[1], feature.geometry.coordinates[0]];
    this.concentricCircleLayer = new L.LayerGroup();
    let marker = undefined;
    // let valuesList = Object.values(this.metaData);
    let selectedPointMetaData = feature.properties;
    let queryParams = gisMapComp.params
    let groupName = queryParams['fogView'] == 'forecast' && queryParams['format'] == 'DAILY' ? this.fogSrv.convertMillisToYYYYMMDD(gisMapComp.activeGroup) : gisMapComp.activeGroup
    if (!isNullOrUndefined(this.aviationFogData[selectedPointMetaData['uuid']])) {
      let alertName: any = this.aviationFogData[selectedPointMetaData['uuid']][groupName]
      alertName = alertName == 'Very Dense' ? 'very_dense' : alertName.toLowerCase()
      const pointIcon = L.divIcon({
        html: `<img src=${'../assets/imgs/' + alertName + '_plane' + '.svg'}>`,
        iconSize: [10, 10],
        iconAnchor: [4, 4],
        popupAnchor: [-5, -5],
      });
      marker = L.marker(latLng, { icon: pointIcon, pane: 'depth' });
      this.concentricCircleLayer.addLayer(marker);
    }

    if (marker) {
      // marker.bindPopup("loading...", popupOptionsHover);
      marker.on({
        mouseover: (e:any) => {
        },
        mouseout: (e:any) => {
        },
        click: (e:any) => {
          this.setViewForFogForecastLayers('Airport Boundary', feature.properties, gisMapComp)
        }
      });
    }
    return this.concentricCircleLayer;
  }

  setVectorLayerStyles(layerList: any, gisMapComp: any, isDistrictChecked:any) {
    for (let key in layerList) {
      let layerName = layerList[key]['layerOptions']['layerName'].split(':')[1];
      layerList[key].layerOptions.vectorTileLayerStyles[layerName] = function (properties: any) {
        let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
        let currentLevel: any = hie[hie.indexOf(gisMapComp.params.locType) + 1];
        let levelBoundary = gisMapComp.gisUtils.titleCase(gisMapComp.params.locType) + ' ' + 'Boundaries';
        gisMapComp.map.eachLayer((layer: any) => {
          if (layer.options.layer_name === levelBoundary) {
            if (gisMapComp.map.hasLayer(layer)) {
              gisMapComp.map.removeLayer(layer);
            }
          }
        });
        let nextLevelUUID;
        if (currentLevel == 'DISTRICT') {
          nextLevelUUID = 'State_UUID';
        } else if (currentLevel == 'BLOCK') {
          nextLevelUUID = 'Dist_UUID'
        } else {
          nextLevelUUID = 'UUID'
        }
        let locUUID: any
        if (currentLevel == 'DISTRICT') {
          locUUID = properties['State_UUID'];
        } else if (currentLevel == 'BLOCK') {
          locUUID = properties['UUID'];
        } else {
          locUUID = properties[nextLevelUUID];
        }
        let style: any;
        if (currentLevel == 'STATE' && key == 'District Boundary') {
          style = {
            color: '#9A8873',
            fill: false,
            weight: isDistrictChecked ? 0.25 : 0,
            // opacity: 1,
            // fillColor: 'transparent',
            // fillOpacity: 0.5
          }
        } else {
          style = {
            color: '#00ffff',
            fill: false,
            weight: key == 'State Boundary' ? 0.5 : 1,
            // opacity: 1,
            // fillColor: 'transparent',
            // fillOpacity: 0.5
          }
        }
      //    else {
      //     style = {
      //       color: 'transparent',
      //       fill: false,
      //       // weight: 0.25,
      //       // opacity: 1,
      //       fillColor: 'transparent',
      //       // fillOpacity: 0.5
      //     }
      //   }
        return style
      }
    }
  }

  setVectorLayerStylesForFogAlert(layerList: any, gisMapComp: any, fogAlertData:any, groupName:any) {
    for (let key in layerList) {
      let layerName = layerList[key]['layerOptions']['layerName'].split(':')[1];
      layerList[key].layerOptions.vectorTileLayerStyles[layerName] = function (properties: any) {
        let hie: any = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE;
        let currentLevel: any = hie[hie.indexOf(gisMapComp.params.locType) + 1];
        let levelBoundary = gisMapComp.gisUtils.titleCase(gisMapComp.params.locType) + ' ' + 'Boundaries';
        gisMapComp.map.eachLayer((layer: any) => {
          if (layer.options.layer_name === levelBoundary) {
            if (gisMapComp.map.hasLayer(layer)) {
              gisMapComp.map.removeLayer(layer);
            }
          }
        });
        let uuid = properties.uuid;
        let style: any;
        let trackColor: any = fogAlertData[uuid] && fogAlertData[uuid][groupName] ? ALERT_COLOR_MAPPING[fogAlertData[uuid][groupName]] : '#808080'

        if (key == 'Railway Boundary') {
          style = {
            color: trackColor,
            fill: false,
            weight: 1.5,
            dashArray: '2 6',           // ⬅ dashed (NOT dotted)
            lineCap: 'round',           // smoother dash edges
            lineJoin: 'round',
            // opacity: 1,
            // fillColor: 'transparent',
            // fillOpacity: 0.5
          }
        } else if (key == 'Airport Boundary' || key == 'Highway Boundary') {
          style = {
            color: trackColor,
            fill: false,
            weight: 1,
          }
        } else {
          style = {
            // color: '#000000',
            fill: false,
            weight: 0,
            // opacity: 1,
            // fillColor: 'transparent',
            // fillOpacity: 0.5
          }
        }
        // }
        return style
      }
    }
  }

  formatLayersData(gisMapComp: any, layerList: any) {
    for (let layerName in layerList) {
      if (layerList[layerName].layerOptions.cql_filter_value) {
        layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + gisMapComp.params['pUUID'] + "'";
      }
    }
    return layerList;
  }

  changeTimeLayers(gis:any, groupName:any) {
    if (groupName != gis.activeGroup) {
      const oldGroupName = gis.activeGroup;
      gis.activeGroup = groupName;
      this.activeGroup = groupName
      this.removeGroupTimeLayers(gis, oldGroupName);
      this.addGroupTimeLayers(gis, groupName);
      this.updateFogHeaderCount(gis)
      this.updateSectorWiseLayers(gis)
    }
  }

  removeGroupTimeLayers(gis:any, groupName:any) {
    for (const index in gis.layers.heatmaplayers) {
      const layer = gis.layers.heatmaplayers[index];
      if (layer['groupName'] == groupName && layer['type'] == 'Time' && !isNullOrUndefined(layer['layer'])) {
        gis.map.removeLayer(layer['layer']);
        gis.layers.heatmaplayers[index] = 'deleted';
      }
      delete gis.layers.heatmaplayers[index];
    }
  }

  addGroupTimeLayers(gis:any, groupName:any) {
    for (const index in gis.activeLayers) {
      const layer = gis.activeLayers[index];
      if (layer['type'] == 'Time' && layer['groupName'] == groupName) {
        if (layer['layer'] != null && layer['layer'] != undefined) {
          layer['layer'].addTo(gis.map);
          gis.layers.heatmaplayers[index] = layer;
        }
        if (!isNullOrUndefined(this.infoboxComp) && layer['type2'] == 'Forecast') {
          this.infoboxComp.updateSectorAlertData(groupName)
        }
      }
    }
  }

  updateFogHeaderCount(gisMapComp: any) {
    if (!isNullOrUndefined(this.fogInfoCountData)) {
        let params = gisMapComp.params
        let fogViewType = params.fogView == 'observed' ? 'Observed' : 'Forecast'
        let date = fogViewType == 'Forecast' && params['format'] != 'HOURLY' ? this.fogSrv.convertMillisToYYYYMMDD(this.activeGroup)  : this.activeGroup
        const data = this.fogInfoCountData[date]
        if (!isNullOrUndefined(data) && Object.keys(data).length > 0) {
            this.utils.heatwaveMetaData.next(data)
        }
    }
}

  setViewForFogForecastLayers(key:any, properties:any, gisMapComp:any) {
    let sectorName = FOGALERT_VIEWTYPE[key]
    let pName = this.propertiesMapping[sectorName]
    let params = gisMapComp.params
    let groupName = params['format'] == 'DAILY' ? this.fogSrv.convertMillisToYYYYMMDD(gisMapComp.activeGroup) : gisMapComp.activeGroup
    let category = this[this.alertDataMap[sectorName]][properties.uuid][groupName]
    let infoObj: any = {
      view: FOGALERT_VIEWTYPE[key],
      location: sectorName == 'Highway' ? properties[pName] + ' (' + properties['dist'] + ')' : properties[pName],
      showLocationAlert: true,
      alertCategory: category,
      forecastDate: this.fogSrv.formatYYYYMMDD(groupName),
      iconClass: SECTOR_ICON_CLASS[sectorName],
      sectorData: this[this.alertDataMap[sectorName]],
      activeGroup: this.activeGroup
    }
    this.utils.setViewForFogAlert.next(infoObj)
  }

  getSectorFogAlertData(gisMapComp:any, type:any) {
    return new Promise((resolve, reject) => {
      this.cancelSectorWiseAPICall$.next();
      if (isEmptyObject(this[this.alertDataMap[type]])) {
        let postData: any;
        let params = gisMapComp.params
        let fogSource = FORMAT_VS_SOURCEMAPPING[params.format][params.source]
        if (type != 'Airport') {
          postData = {
            "pUuid": params.pEUUID,
            "pType": "COUNTRY",
            "cType": this.cTypeMapping[type],
            "source": fogSource
          }
        } else {
          postData = {
            "pEUUID": params.pEUUID,
            "pUUID": params.pEUUID,
            "pType": "COUNTRY",
            "cType": this.cTypeMapping[type],  //AVIATION 
            "source": fogSource,  //ecmwf_1hr  EUMETSAT_FOG_NOWCAST
            "hoursCount": 8
          }
        }
        gisMapComp.showThrobber = true
        this.fogSrv.getSectorWiseFogAlertData(postData, FOGALERT_API_MAPPING[type]).pipe(takeUntil(this.cancelSectorWiseAPICall$)).subscribe(data => {
          if (!isNullOrUndefined(data) && !isEmptyObject(data)) {
            let formattedResponse = this.fogSrv.formatFogAlertData(data)
            this[this.alertDataMap[type]] = formattedResponse
            gisMapComp.showThrobber = false
            resolve(formattedResponse)
          } else {
            gisMapComp.showThrobber = false
            resolve({})
          }
        }, err => {
          gisMapComp.showThrobber = false
          resolve({})
        })
      } else {
        resolve(this[this.alertDataMap[type]])
      }
    })
  }

  updateSectorWiseLayers(gisMapComp:any) {
    let params = gisMapComp.params
    if (this.isAviationChecked) {
      this.removeToggledLayer(gisMapComp, 'Airport')
      this.handleSectorWiseLayers(gisMapComp, params, 'Airport Boundary', this.isAviationChecked,true)
    } else if (this.isRailwayChecked) {
      this.removeToggledLayer(gisMapComp, 'Railway')
      this.handleSectorWiseLayers(gisMapComp, params, 'Railway Boundary', this.isRailwayChecked,true)
    } else if (this.isHighwayChecked) {
      this.removeToggledLayer(gisMapComp, 'Highway')
      this.handleSectorWiseLayers(gisMapComp, params, 'Highway Boundary', this.isHighwayChecked,true)
    }
  }
}
